<app-breadcrumb
  [title]="'permanentFile.title' | translate"
  [items]="[('permanentFile.dashboard' | translate)]"
  [active_item]="''">
</app-breadcrumb>

<div class="container-fluid pf-page">
  <div class="card pf-card">
    <div class="card-body">
      <h2 class="pf-heading">{{ 'permanentFile.sendSection' | translate }}</h2>
      <p class="pf-lead">{{ 'permanentFile.lead' | translate }}</p>

      <form [formGroup]="createZip">
        <div class="row">
          <div class="col-xxl-4 col-sm-6 p-2">
            <label class="form-label pf-label">{{ 'permanentFile.selectCompany' | translate }}</label>
            <ng-select
              class="ng-select-custom permanent-file-company-select"
              formControlName="company_id"
              [items]="mastercompany"
              bindValue="company_id"
              [searchable]="true"
              [clearable]="false"
              appendTo="body"
              dropdownPanelClass="permanent-file-company-dropdown"
              [placeholder]="'permanentFile.select' | translate"
            >
              <ng-template ng-label-tmp let-item="item">
                <span>{{ getCompanyDisplayName(item) }}</span>
              </ng-template>
              <ng-template ng-option-tmp let-item="item">
                <span>{{ getCompanyDisplayName(item) }}</span>
              </ng-template>
            </ng-select>
          </div>

          <div class="col-xxl-4 col-sm-6 p-2">
            <label class="form-label pf-label" for="permanent-file-start">{{ 'permanentFile.startDate' | translate }}</label>
            <input id="permanent-file-start" class="form-control" type="date" formControlName="start_date" />
          </div>

          <div class="col-xxl-4 col-sm-6 p-2">
            <label class="form-label pf-label" for="permanent-file-end">{{ 'permanentFile.endDate' | translate }}</label>
            <input id="permanent-file-end" class="form-control" type="date" formControlName="end_date" />
          </div>
        </div>

        <p class="pf-hint" *ngIf="oauthState === 'unknown'">{{ 'permanentFile.linkSeparate' | translate }}</p>

        <div class="pf-oauth" *ngIf="oauthState === 'missing' || oauthState === 'expired'" [class.is-attention]="oauthAttention">
          <div class="pf-oauth-copy">
            <strong>{{ (oauthState === 'expired' ? 'permanentFile.linkExpiredTitle' : 'permanentFile.linkMissingTitle') | translate }}</strong>
            <p>{{ (oauthState === 'expired' ? 'permanentFile.linkExpiredBody' : 'permanentFile.linkMissingBody') | translate }}</p>
            <p class="pf-oauth-hint">{{ 'permanentFile.linkHint' | translate }}</p>
            <p class="pf-oauth-hint" *ngIf="linkDetail" dir="auto">{{ linkDetail }}</p>
          </div>
        </div>

        <p class="pf-error" *ngIf="createZip.hasError('range')">{{ 'permanentFile.invalidRange' | translate }}</p>
        <p class="pf-error" *ngIf="actionError">{{ actionError }}</p>

        <div class="pf-actions">
          <button
            type="button"
            class="btn pf-btn pf-btn-link"
            (click)="connectCompany()"
            [disabled]="!companyId || connecting"
          >
            <i class="fa" [ngClass]="connecting ? 'fa-spinner fa-spin' : 'fa-link'" aria-hidden="true"></i>
            {{ (connecting ? 'permanentFile.connecting' : 'permanentFile.linkAction') | translate }}
          </button>
          <button
            type="button"
            class="btn pf-btn pf-btn-primary"
            (click)="submitToAuthority()"
            [disabled]="createZip.invalid || submitting"
          >
            <i class="fa" [ngClass]="submitting ? 'fa-spinner fa-spin' : 'fa-paper-plane'" aria-hidden="true"></i>
            {{ (submitting ? 'permanentFile.submitting' : 'permanentFile.submit') | translate }}
          </button>
          <button
            type="button"
            class="btn pf-btn pf-btn-ghost"
            (click)="downloadLocal()"
            [disabled]="createZip.invalid || downloading"
          >
            <i class="fa" [ngClass]="downloading ? 'fa-spinner fa-spin' : 'fa-download'" aria-hidden="true"></i>
            {{ (downloading ? 'permanentFile.downloading' : 'permanentFile.downloadLocal') | translate }}
          </button>
        </div>
        <p class="pf-hint">{{ 'permanentFile.submitHint' | translate }}</p>
      </form>
    </div>
  </div>

  <div class="card pf-card" id="unistruct-jobs" *ngIf="companyId">
    <div class="card-body">
      <div class="pf-section-head">
        <h2 class="pf-heading">{{ 'permanentFile.jobsTitle' | translate }}</h2>
        <button type="button" class="pf-text-btn" (click)="loadJobs()" [disabled]="jobsLoading">
          <i class="fa" [ngClass]="jobsLoading ? 'fa-spinner fa-spin' : 'fa-refresh'" aria-hidden="true"></i>
          {{ 'permanentFile.refreshList' | translate }}
        </button>
      </div>

      <p class="pf-muted" *ngIf="jobsLoading && !jobs.length">{{ 'permanentFile.jobsLoading' | translate }}</p>
      <p class="pf-error" *ngIf="jobsError">{{ jobsError }}</p>
      <p class="pf-muted" *ngIf="!jobsLoading && !jobsError && !jobs.length">{{ 'permanentFile.jobsEmpty' | translate }}</p>

      <article class="pf-job" *ngFor="let job of jobs; trackBy: trackJob" [id]="'unistruct-job-' + job.job_id">
        <div class="pf-job-head">
          <button
            type="button"
            class="pf-job-toggle"
            (click)="toggleJob(job)"
            [attr.aria-expanded]="expandedJobId === job.job_id"
          >
            <span class="pf-period">{{ formatPeriod(job.start_period) }} – {{ formatPeriod(job.end_period) }}</span>
            <span class="pf-badge" [ngClass]="statusClass(job)" aria-live="polite">{{ statusLabel(job) }}</span>
            <i class="fa pf-chevron" [ngClass]="expandedJobId === job.job_id ? 'fa-chevron-up' : 'fa-chevron-down'" aria-hidden="true"></i>
          </button>
          <button
            type="button"
            class="btn pf-btn pf-btn-retry"
            *ngIf="job.ui.can_retry"
            (click)="retry(job, $event)"
            [disabled]="isBusy(job)"
          >
            <i class="fa" [ngClass]="isBusy(job) ? 'fa-spinner fa-spin' : 'fa-refresh'" aria-hidden="true"></i>
            {{ (isBusy(job) ? 'permanentFile.retrying' : 'permanentFile.retry') | translate }}
          </button>
        </div>

        <div class="pf-job-body" *ngIf="expandedJobId === job.job_id">
          <ol class="pf-stepper">
            <li *ngFor="let step of stepsFor(job)" class="pf-step" [ngClass]="'is-' + step.state">
              <span class="pf-step-mark" [attr.aria-current]="step.state === 'active' ? 'step' : null">
                <i *ngIf="step.state === 'done' || step.state === 'success'" class="fa fa-check" aria-hidden="true"></i>
                <i *ngIf="step.state === 'error'" class="fa fa-times" aria-hidden="true"></i>
              </span>
              <span class="pf-step-label">{{ ('permanentFile.steps.' + step.key) | translate }}</span>
            </li>
          </ol>

          <div class="pf-reject" *ngIf="job.rejection_reason">
            <strong>{{ 'permanentFile.rejectionReason' | translate }}</strong>
            <p dir="auto">{{ job.rejection_reason }}</p>
          </div>

          <div class="pf-relink" *ngIf="needsRelink(job)">
            <p>{{ 'permanentFile.linkExpiredBody' | translate }}</p>
            <button type="button" class="btn pf-btn pf-btn-primary" (click)="connectCompany()" [disabled]="connecting">
              <i class="fa" [ngClass]="connecting ? 'fa-spinner fa-spin' : 'fa-link'" aria-hidden="true"></i>
              {{ (connecting ? 'permanentFile.connecting' : 'permanentFile.linkAction') | translate }}
            </button>
          </div>

          <div class="pf-meta">
            <span *ngIf="job.record_count != null">{{ 'permanentFile.records' | translate }}: {{ job.record_count }}</span>
            <span *ngIf="job.case_number">{{ 'permanentFile.caseNumber' | translate }}: {{ job.case_number }}</span>
          </div>

          <p class="pf-live" *ngIf="isLive(job)">{{ 'permanentFile.pollingHint' | translate }}</p>
        </div>
      </article>
    </div>
  </div>
</div>
